import { useCallback } from 'react';
import type { MouseEventHandler } from 'react';

interface UseAnalyticsReportClicksProps {
  reportBiOnClick?: MouseEventHandler;
  onClick?: MouseEventHandler;
}

export const useAnalyticsReportClicks = ({
  reportBiOnClick,
  onClick: propsOnClick,
}: UseAnalyticsReportClicksProps): MouseEventHandler => {
  return useCallback<MouseEventHandler>(
    event => {
      reportBiOnClick?.(event);
      propsOnClick?.(event);
    },
    [reportBiOnClick, propsOnClick],
  );
};
